import React from 'react';
import './PrivacyPolicy.css';
import { Helmet } from 'react-helmet-async';
function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Terms of Use - Cognitva Global Technologies Private Limited</title>
        <meta name="description" content="Cognitva Global Technologies Private Limited's official website's Terms of Use, Privacy Policy, and Cookie Policy. Learn about our commitment to user privacy and data protection." />
        <meta name="keywords" content="Cognitva, Terms of Use, Privacy Policy, Cookie Policy, Data Protection, User Rights" />
        <link rel="canonical" href="https://www.cognitva.ai/terms-of-user" />
        <meta property="og:title" content="Cognitva Global Technologies Private Limited - Terms of Use, Privacy & Cookie Policy" />
        <meta property="og:description" content="Cognitva Global Technologies Private Limited's official website's Terms of Use, Privacy Policy, and Cookie Policy. Learn about our commitment to user privacy and data protection." />
        <meta property="og:url" content="https://www.cognitva.ai/terms-of-user" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.cognitva.ai/images/cognitva-logo.png" />

      </Helmet>
      <div className="privacy-policy-container">
        <div className="terms-of-user-header">
          <h1>Cognitva Global Technologies Private Limited Website's Terms of Use, Privacy & Cookie Policy</h1>
          <p className="effective-date">Effective date: 8th of June, 2025</p>
        </div>

        <div className="terms-of-user-group">
          <div className="terms-section">
            <h2>Terms of user</h2>
            <p>Welcome to the official website of Cognitva Global Technologies Private Limited ("Cognitva", "we", "us", or "our"). By accessing or using our website and associated services, you agree to be legally bound by these Terms of Use. If you do not agree to these terms, please do not use our website.</p>
          </div>

          <div className="terms-subsection">
            <h3>Eligibility</h3>
            <p>You must be at least 18 years of age to use this website. By accessing it, you confirm that you are eligible.</p>
          </div>

          <div className="terms-subsection">
            <h3>Intellectual Property</h3>
            <p>All content, trademarks, logos, graphics, and software on the website are the intellectual property of Cognitva and may not be reproduced or used without explicit written permission.</p>
          </div>

          <div className="terms-subsection">
            <h3>User Conduct</h3>
            <p>You agree not to use the website for any unlawful, harmful, or malicious purpose including unauthorized access, data extraction, or website disruption.</p>
          </div>

          <div className="terms-subsection">
            <h3>Disclaimer</h3>
            <p>All content is provided "as is." Cognitva makes no warranties about the completeness, reliability, or accuracy of the website or its content.</p>
          </div>

          <div className="terms-subsection">
            <h3>Limitation of Liability</h3>
            <p>Cognitva shall not be liable for any indirect, incidental, special, or consequential damages resulting from your use of the website.</p>
          </div>
        </div>

        {/* Add placeholders for Privacy Policy and Cookies Policy sections */}
        <div className="terms-section" id="privacy-policy">
          <h2>Privacy Policy</h2>
          <p>We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information.</p>

          <div className="privacy-policy-indented-content">
            <h3>Information We Collect</h3>
            <ul>
              <li>Personal identifiers (e.g., name, email, phone number) if you submit forms - Technical data (IP address, browser type, time zone)</li>
              <li>Usage data (pages visited, duration, interactions)</li>
            </ul>

            <h3>Use of Information</h3>
            <p>We use collected data to:</p>
            <ul>
              <li>Respond to queries and contact requests</li>
              <li>Improve website performance and product experience - Provide information on our AI products and services</li>
            </ul>

            <h3>Data Protection</h3>
            <p>We implement technical and organizational measures to protect your data. We do not sell or share your data with third parties for marketing.</p>

            <h3>Data Retention</h3>
            <p>Your personal data is retained only as long as necessary for business purposes or as required by law.</p>

            <h3>Your Rights</h3>
            <p>You have the right to access, correct, or delete your data by contacting us at privacy@cognitva.ai.</p>

            <h3>Third-Party Links</h3>
            <p>Our website may contain links to external sites. We are not responsible for their content or privacy practices.</p>
          </div>
        </div>

        <div className="section-divider"></div>

        <div className="terms-section" id="cookies-policy">
          <h2>Cookie Policy</h2>
          <p>We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information.</p>

          <div className="privacy-policy-indented-content">
            <h3>Use of Cookies</h3>
            <p>Our website uses cookies to enhance user experience, analyze traffic, and personalize content.</p>

            <h3>Types of Cookies Used</h3>
            <ul>
              <li>Essential cookies for functionality</li>
              <li>Analytics cookies to measure performance - Preference cookies to store user settings</li>
            </ul>

            <h3>Managing Cookies</h3>
            <p>You can modify your browser settings to decline or delete cookies. Note that this may affect your website experience.</p>
          </div>
        </div>

        <div className="section-divider"></div>

        <div className="terms-section">
          <h2>Modifications</h2>
          <p>Cognitva reserves the right to modify these policies at any time. Updates will be reflected on this page with a revised effective date.</p>
        </div>

        <div className="section-divider"></div>

        <div className="terms-section">
          <h2>Contact Us</h2>
          <p>For questions regarding these terms or our data practices:</p>
          <h3>Cognitva Global Technologies Private Limited</h3>
          <p>Email: <a href="mailto:legal@cognitva.ai">legal@cognitva.ai</a></p>
          <p>These policies govern your access to the Cognitva website and product interfaces.</p>
        </div>

      </div>
    </>
  );
}

export default PrivacyPolicy; 